import React, { useRef, useEffect } from 'react'

const NISGComp = () => {
    const widgetRef = useRef(null);

    useEffect(() => {
        if (widgetRef.current) {
            window.chat_widget_reference_no = '6rv66dk66rupat1tc4r30eb46wu34cb365h3arg';
            window.bot_type = 'Mobi';

            const link = document.createElement('link');
            link.href = 'https://talkkwebchat.talkk.ai/index.css';
            link.rel = 'stylesheet';
            document.head.appendChild(link);

            const scriptPing = document.createElement('script');
            scriptPing.src = 'https://chat.talkk.ai/ping';
            scriptPing.async = true;
            document.body.appendChild(scriptPing);

            const scriptIndex = document.createElement('script');
            scriptIndex.src = 'https://talkkwebchat.talkk.ai/index.js';
            scriptIndex.async = true;
            document.body.appendChild(scriptIndex);

            return () => {
                document.body.removeChild(scriptPing);
                document.body.removeChild(scriptIndex);
                document.head.removeChild(link);
            };
        }
    }, []);
    return (
        <div ref={widgetRef} className="chat_talkk_widget" data-subreddit="reactjs"></div>
    )
}

export default NISGComp